module.exports = __webpack_public_path__ + "img/19.55bf5d02.png";